import { AreaId } from '@cutr/constants/windows/windows';
import {
  NewAreaDimension,
  NewFrameDimension,
} from '@cutr/constants/windows/windows-presets.ts';
import React from 'react';

import { usePositionStore } from '@/windows/api/positionStore';

import { useKonva } from './KonvaContext';

export const events = {
  frameDimensionChange: 'frameDimensionChange',
  areaDimensionChange: 'areaDimensionChange',
  areaSelected: 'areaSelected',
};

export type EventTypes = {
  frameDimensionChange: NewFrameDimension;
  areaDimensionChange: NewAreaDimension;
  areaSelected: AreaSelected;
};

export type AreaSelected = {
  areaId: AreaId;
};

export const useEditorEvents = () => {
  const { resize, toggleSelectedAreaId } = usePositionStore();
  const { stageRef } = useKonva();

  React.useEffect(() => {
    const stageElement = stageRef.current;
    if (!stageElement) return;

    stageElement.on(events.frameDimensionChange, (event) => {
      const { name, value } =
        event as unknown as EventTypes['frameDimensionChange'];

      resize({ value, name, target: 'frame' });
    });

    stageElement.on(events.areaDimensionChange, (event) => {
      const { dimension, index, value } =
        event as unknown as EventTypes['areaDimensionChange'];

      resize({ value, index, dimension, target: 'area' });
    });

    stageElement.on(events.areaSelected, (event) => {
      const { areaId } = event as unknown as EventTypes['areaSelected'];

      toggleSelectedAreaId(areaId);
    });

    return () => {
      stageElement.off(events.frameDimensionChange);
      stageElement.off(events.areaDimensionChange);
      stageElement.off(events.areaSelected);
    };
  }, [resize, stageRef, toggleSelectedAreaId]);
};
